module.exports = __webpack_public_path__ + "static/img/johnhammersley.bd01ac82.jpg";